module.exports = __webpack_public_path__ + "img/contact_join_03.74f88967.png";